// extracted by mini-css-extract-plugin
export default {"modal-confirm":"EditConfirmationModal_modal-confirm__P3MgH"};